import React, {useEffect, useMemo} from 'react'
import {useFieldValue, useFormSelector} from './context'
import useFormField from './use_form_field'
import _ from 'lodash'

export const useRegisterField = (field, fieldProps) => {
	const registerField = useFormSelector('registerField') || _.noop
	const unregisterField = useFormSelector('unregisterField') || _.noop
	const enhanceField = useFormSelector('enhanceField') || _.noop
	const value = useFieldValue(field)
	const error = useFormSelector(`errors.${field}`)
	const isTouched = useFormSelector(ctx => ctx.touchedFields?.includes(field))
	const formDataDependencies = fieldProps?.formDataDependencies
	const formDataVersion = useFormSelector(ctx => {
		if (!formDataDependencies) return ctx.fields
		return formDataDependencies
			.map(key => {
				const val = ctx.fields?.[key]
				return _.isPlainObject(val) || _.isArray(val) ? JSON.stringify(val) : String(val)
			})
			.join('||')
	})

	useEffect(() => {
		registerField(field, fieldProps)
		return () => unregisterField(field)
	}, [field])

	const getData = useFormSelector('getData')

	const baseProps = enhanceField(field, fieldProps) || {}
	const formData = useMemo(() => {
		const currentFormData = getData()
		if (!formDataDependencies) return currentFormData
		return _.pick(currentFormData, formDataDependencies)
	}, [formDataDependencies, formDataVersion])
	return {
		...baseProps,
		error,
		formData,
		value,
		isTouched,
	}
}

export const makeRegisteredField = Comp => props => {
	const formProps = useRegisterField(props.field, props)
	const formFieldProps = useFormField(formProps)
	return <Comp {...props} {...formProps} {...formFieldProps} form />
}
